import { Injectable, EventEmitter } from '@angular/core';

function _window() : any {
    // return the global native browser window object
    return window;
 } 
@Injectable()
export class SharedService {
    blockedDocument = new EventEmitter<any>();
    loaderHide=new EventEmitter<any>();
    openOverlayFormEvent = new EventEmitter<any>();
    openOverlayshareTextEvent = new EventEmitter<any>();
} 


@Injectable()
export class WindowRef {
    get nativeWindow() : any {
        return _window();
     }
}
